import { Component, OnInit } from '@angular/core';

import { LangagesService } from 'src/app/services/manage/langages/langages.service';
import { ToolsService } from 'src/app/services/tools/tools.service';

@Component({
  selector: 'app-languages',
  templateUrl: './languages.component.html',
  styleUrls: ['./languages.component.css'],
})

export class LanguagesComponent implements OnInit {

  languages: any = [
    {
      url: "assets/img/countryflag/angleterre.png",
      value: "en",
      translate: "langs.en"
    },
    {
      url: "assets/img/countryflag/france.png",
      value: "fr",
      translate: "langs.fr"

    },
    {
      url: "assets/img/countryflag/espagne.png",
      value: "es",
      translate: "langs.es"
    }
  ];


  langSelected: any;
  constructor(
   
    private tools: ToolsService,
    public LangagesService: LangagesService,

  ) { }

  ngOnInit() {

    this.setflag();
  }

  chooseLanguage(language: string): void {
  

    this.LangagesService.setCurrlang(language);

    this.setflag();

    //on actualise la page
    setTimeout(() => {
      window.location.reload();
    }, 0);


  }

  setflag() {
    let selectedLang = this.tools.getStor("lang") ? this.tools.getStor("lang") : "fr";
    this.langSelected = this.languages.find((value: any) => (value.value == selectedLang));
  }

}
